"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.instructions.title': 'Instrukcje Trainera LLM',
    'trainer.instructions.subtitle': 'Wykonaj te kroki, aby wytrenować swój niestandardowy model językowy',
    'trainer.instructions.overview': 'Przegląd',
    'trainer.instructions.overview.text': 'To narzędzie pomaga dostrajać duże modele językowe używając twoich własnych danych treningowych. Proces obejmuje cztery główne kroki:',
    'trainer.instructions.step.upload': 'Dostarczenie przykładów treningowych w formacie CSV',
    'trainer.instructions.step.config': 'Ustawienie parametrów modelu i opcji treningu',
    'trainer.instructions.step.monitor': 'Obserwowanie treningu modelu w czasie rzeczywistym',
    'trainer.instructions.step.review': 'Ocena i wdrożenie wytrenowanego modelu',
    'trainer.instructions.data.requirements': 'Wymagania Dotyczące Danych',
    'trainer.instructions.csv.format': 'Wymagany Format CSV',
    'trainer.instructions.csv.text': 'Twoje dane treningowe muszą być w formacie CSV z tymi kolumnami:',
    'trainer.instructions.csv.input': 'Tekst zapytania/promptu (wymagany)',
    'trainer.instructions.csv.output': 'Oczekiwana odpowiedź/wynik (wymagany)',
    'trainer.instructions.csv.category': 'Kategoria klasyfikacji (opcjonalny)',
    'trainer.instructions.example.csv': 'Przykładowe Dane CSV:',
    'trainer.instructions.copy': 'Kopiuj',
    'trainer.instructions.backend.format': 'Format Danych Backendu',
    'trainer.instructions.jsonl.format': 'Format Konwersacyjny JSONL',
    'trainer.instructions.jsonl.text': 'Twoje dane CSV zostaną automatycznie przekonwertowane do formatu JSONL dla fine-tuningu:',
    'trainer.instructions.jsonl.example': 'Wygenerowany Format JSONL:',
    'trainer.instructions.format.notes': 'Uwagi o Formacie:',
    'trainer.instructions.format.note1': 'Każda linia zawiera kompletną konwersację z wiadomościami systemu, użytkownika i asystenta',
    'trainer.instructions.format.note2': 'Prompt systemowy pomaga ustanowić zachowanie modelu',
    'trainer.instructions.format.note3': 'Wiadomość użytkownika zawiera twoje dane wejściowe',
    'trainer.instructions.format.note4': 'Wiadomość asystenta zawiera twoją oczekiwaną odpowiedź',
    'trainer.instructions.best.practices': 'Najlepsze Praktyki',
    'trainer.instructions.data.quality': 'Jakość Danych',
    'trainer.instructions.quality.tip1': 'Użyj co najmniej 50-100 wysokiej jakości przykładów',
    'trainer.instructions.quality.tip2': 'Zapewnij spójne formatowanie i styl',
    'trainer.instructions.quality.tip3': 'Unikaj duplikatów lub sprzecznych przykładów',
    'trainer.instructions.quality.tip4': 'Uwzględnij różnorodne przykłady pokrywające twój przypadek użycia',
    'trainer.instructions.training.config': 'Konfiguracja Treningu',
    'trainer.instructions.config.tip1': 'Zacznij od 3-5 epok do wstępnych testów',
    'trainer.instructions.config.tip2': 'Użyj współczynnika uczenia 0.0001 dla większości przypadków',
    'trainer.instructions.config.tip3': 'Ustaw podział walidacji na 20% do monitorowania',
    'trainer.instructions.config.tip4': 'Wybierz znaczące nazwy modeli',
    'trainer.instructions.model.selection': 'Wybór Modelu',
    'trainer.instructions.selection.tip1': 'Użyj modeli instrukcji do zadań konwersacyjnych',
    'trainer.instructions.selection.tip2': 'Zacznij od mniejszych modeli (8B) do testowania',
    'trainer.instructions.selection.tip3': 'Rozważ większe modele (70B) do złożonych zadań',
    'trainer.instructions.selection.tip4': 'Włącz fine-tuning LoRA dla wydajności',
    'trainer.instructions.monitoring': 'Monitorowanie',
    'trainer.instructions.monitor.tip1': 'Obserwuj jak wartości strat maleją z czasem',
    'trainer.instructions.monitor.tip2': 'Monitoruj metryki walidacji pod kątem przeuczenia',
    'trainer.instructions.monitor.tip3': 'Zatrzymaj wcześnie jeśli strata walidacji rośnie',
    'trainer.instructions.monitor.tip4': 'Przetestuj swój model dokładnie po treningu',
    'trainer.instructions.troubleshooting': 'Rozwiązywanie Problemów',
    'trainer.instructions.trouble.upload': 'Niepowodzenie Wgrywania Pliku',
    'trainer.instructions.upload.fix1': 'Sprawdź czy twój plik jest w formacie CSV',
    'trainer.instructions.upload.fix2': 'Upewnij się że wymagane kolumny (wejście, wyjście) są obecne',
    'trainer.instructions.upload.fix3': 'Sprawdź czy CSV jest poprawnie sformatowany z nagłówkami',
    'trainer.instructions.upload.fix4': 'Spróbuj mniejszych rozmiarów plików (poniżej 10MB)',
    'trainer.instructions.trouble.validation': 'Błędy Walidacji',
    'trainer.instructions.validation.fix1': 'Sprawdź puste pola wejścia lub wyjścia',
    'trainer.instructions.validation.fix2': 'Usuń lub napraw nieprawidłowe wiersze CSV',
    'trainer.instructions.validation.fix3': 'Zapewnij spójną strukturę kolumn',
    'trainer.instructions.validation.fix4': 'Sprawdź czy znaki specjalne są poprawnie escaped',
    'trainer.instructions.trouble.slow': 'Trening Zbyt Wolny',
    'trainer.instructions.slow.fix1': 'Zmniejsz liczbę epok',
    'trainer.instructions.slow.fix2': 'Użyj mniejszych rozmiarów partii',
    'trainer.instructions.slow.fix3': 'Wybierz mniejszy model bazowy',
    'trainer.instructions.slow.fix4': 'Włącz fine-tuning LoRA',
    'trainer.instructions.trouble.performance': 'Słaba Wydajność Modelu',
    'trainer.instructions.performance.fix1': 'Zwiększ ilość danych treningowych',
    'trainer.instructions.performance.fix2': 'Popraw jakość i spójność danych',
    'trainer.instructions.performance.fix3': 'Dostosuj współczynnik uczenia (spróbuj 0.00001)',
    'trainer.instructions.performance.fix4': 'Trenuj przez więcej epok',
    'trainer.instructions.ready': 'Gotowy do Rozpoczęcia?',
    'trainer.instructions.ready.text': 'Gdy już rozumiesz wymagania:',
    'trainer.instructions.ready.step1': 'Przygotuj swój plik CSV z parami wejście/wyjście',
    'trainer.instructions.ready.step2': 'Kliknij zakładkę "Wgraj Dane" powyżej aby rozpocząć',
    'trainer.instructions.ready.step3': 'Podążaj za prowadzonym przepływem pracy przez każdy krok',
    'trainer.instructions.ready.step4': 'Monitoruj postęp swojego treningu',
    'trainer.instructions.ready.step5': 'Testuj i wdrażaj swój wytrenowany model',
    'trainer.instructions.good.luck': 'Powodzenia z trenowaniem twojego modelu! 🎉',
};
